document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.getElementById("mobile-drawer");
  const openBtn = document.querySelector(".drawer-toggle");
  const closeBtn = document.querySelector(".drawer-close");

  openBtn.addEventListener("click", () => {
    drawer.classList.add("open");
  });

  closeBtn.addEventListener("click", () => {
    drawer.classList.remove("open");
  });

  // Close drawer when clicking outside
  drawer.addEventListener("click", (e) => {
    if (e.target === drawer) {
      drawer.classList.remove("open");
    }
  });
});

// sticky-header.js
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.site-header.sticky-header');

  if (!header) return; // exit if no header found

  const body = document.body;

  // Add/remove class on scroll
  window.addEventListener('scroll', function () {
    if (header.classList.contains('is-sticky')) {
      body.classList.add('sticky-active');
    } else {
      body.classList.remove('sticky-active');
    }
  });
});

